import config from './config'

export const AIAPI = {
    getTemplatePrompt: (aiPrompt) => {
        return config.post(`/api/ai/template_prompt/`, { prompt: aiPrompt })
    },
}
